
/**
 * @export
 * @enum {string}
 */
export enum LocaleTimezone {
    APAC = 'APAC',
    Europe = 'Europe',
    US = 'US'
}